import { Chip } from '@/components/Chip';
import { Tone } from '@gokrew/models/ui.types';
import type { AssignmentStatus } from '@gokrew/models/tasks';
import { useTranslation } from 'react-i18next';
import { TranslationNS } from '@gokrew/models/constants';

const STATUS_CONFIG: Record<AssignmentStatus, { tone: Tone }> = {
  not_started: { tone: Tone.NEUTRAL },
  in_progress: { tone: Tone.SOFT_BLUE },
  submitted: { tone: Tone.WARNING },
  approved: { tone: Tone.SUCCESS },
  completed: { tone: Tone.SUCCESS },
};

interface TaskStatusChipProps {
  status: AssignmentStatus;
}

export function TaskStatusChip({ status }: TaskStatusChipProps) {
  const { t } = useTranslation(TranslationNS.LibsCommon);
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.not_started;

  return (
    <Chip type={config.tone} size="sm" showDot>
      {t(`tasks.status.${status}`)}
    </Chip>
  );
}
